module.exports = __webpack_public_path__ + "static/media/about-of-banner.e18c4be4.jpg";